import { nextIteration } from "./_nextIteration.js";
import { typeDataToArray } from "./_typeDataToArray.js";
export const toMap = async (source, selector) => {
    const map = new Map();
    const dataFunc = nextIteration(source, (value) => {
        const key = selector(value);
        return [key, value];
    });
    const keyValues = await typeDataToArray(dataFunc);
    for (const [key, value] of keyValues) {
        const array = map.get(key);
        if (array === undefined) {
            map.set(key, [value]);
        }
        else {
            array.push(value);
        }
    }
    return map;
};
